import { createAsyncThunk } from '@reduxjs/toolkit'
import SocialMediaAccount from './social-media-account-model'
import {
  delete_socialMediaAccount,
  load_socialMediaAccounts,
  store_socialMediaAccount,
} from './socialMediaAccount-service'

export const LoadSocialMediaAccountsAsync = createAsyncThunk<any, any>(
  'composer/load/socialMediaAccount',
  async (params: { uid: string }) => {
    return await load_socialMediaAccounts(params)
  },
)

export const CreateSocialMediaAccountAsync = createAsyncThunk<any, any>(
  'composer/create/socialMediaAccount',
  async (params: SocialMediaAccount) => {
    return await store_socialMediaAccount(params)
  },
)

export const DeleteSocialMediaAccountAsync = createAsyncThunk<any, any>(
  'composer/delete/socialMediaAccount',
  async (params) => {
    return await delete_socialMediaAccount(params)
  },
)
